import {ICrudLocale} from "../../../i18n/interface";

export const ADMINISTRATOR_CENTER_LOCALE_ES: ICrudLocale = {
  ADMINISTRATOR_CENTER: {
    FIELD: {
      NAME: 'Nombre',
      USERNAME: 'Usuario',
      EMAIL: 'Email',
      GENDER: 'Género',
      ENABLED: 'Activo',
      LASTNAME: 'Apellido',
      PASSWORD: 'Contraseña',
      MOBILE: 'Teléfono',
      ROL: 'Rol',
      BIRTHDATE: 'Fecha de nacimiento',
      SELF_GENERATED_PASSWORD: 'Contraseña autogenerada',
      LAST_LOGIN: 'Último acceso',
      CENTER: 'Centro',
      DOC_TYPE: {
        DNI: 'DNI',
        NIE: 'NIE',
        PASSPORT: 'PASSPORT',
      },
    },
    TEXT: {
      DELETE_MESSAGE: 'Si lo eliminas, todos los datos serán borrados.<br> <b>Esta acción no es reversible.</b>',
    },
    ERROR: {
      LOAD_FORM_RESOURCES: 'Lo sentimos ha ocurrido un error al cargar el formulario.',
    },
    LABEL: {
      SINGULAR: 'Gestor de centro',
      PLURAL: 'Gestores  de centros',
    },
    LIST: {
      TITLE: 'Listado de gestores centros'
    }
  }
}
